import { render, staticRenderFns } from "./buyM.vue?vue&type=template&id=78111a84&"
import script from "./buyM.vue?vue&type=script&lang=js&"
export * from "./buyM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports